import NavBar from "@/components/site/NavBar";
import HeroVSL from "@/components/site/HeroVSL";
import AttorneyBar from "@/components/site/AttorneyBar";
import FearSection from "@/components/site/FearSection";
import FounderStory from "@/components/site/FounderStory";
import GoogleReviews from "@/components/site/GoogleReviews";
import Testimonials from "@/components/site/Testimonials";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";

const DV_VIDEO_ID = "6a59d1312c7c951cdbed9681";

const headline = (
  <>
    Are you a victim of{" "}
    <span className="italic font-medium text-teal">domestic violence?</span>
  </>
);

const subhead = (
  <>
    You don&rsquo;t have to answer that question alone.{" "}
    <span className="text-ink font-medium">Binoye Jos, Esq.</span> and the JOS
    Family Law team handle domestic violence cases in Orange County with{" "}
    <span className="text-ink font-medium">complete discretion</span>,{" "}
    <span className="text-ink font-medium">same-week availability</span>, and{" "}
    <span className="text-ink font-medium">no judgment</span>. If you&rsquo;re
    in a dangerous situation at home, the right legal help — quickly and
    privately — can change everything.
  </>
);

export default function DomesticViolenceVSL() {
  return (
    <main data-testid="dv-vsl-page" className="relative bg-paper text-ink">
      <NavBar />
      <HeroVSL
        videoId={DV_VIDEO_ID}
        headline={headline}
        subhead={subhead}
        showStatBar={false}
      />
      <AttorneyBar />
      <FearSection />
      <FounderStory />
      <GoogleReviews />
      <Testimonials />
      <FinalCTA source="DV VSL" />
      <Footer />
    </main>
  );
}
